import { render, staticRenderFns } from "./pip-widget.vue?vue&type=template&id=2d01b246&"
import script from "./pip-widget.vue?vue&type=script&lang=ts&"
export * from "./pip-widget.vue?vue&type=script&lang=ts&"
import style0 from "./pip-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports